export default {
  searchData: {
    year: '',
    month: ''
  },
  searchingCount: 0,
  arrSpaces: [],
  arrProducts: [],
  arrSpaceEchartObj: [],
  arrProductEchartObj: [],
  spaceShowTable: true,
  productShowTable: true,

  downloadData: {
    dateRange: [],
    space: false,
    product: false
  }

}



// WEBPACK FOOTER //
// ./src/store/modules/Statistics/state.js